@if (userInfo(); as userInfo) {
  <div class="container">
    <h1 class="mat-title">Settings</h1>
    <span class="sub-text">Manage your account settings and preferences.</span>

    <h4>General Information</h4>
    <span class="sub-text"> General user information of your account. </span>
    <div class="listing">
      <div class="list-el">
        <div class="el-label">Username:</div>
        <div class="el-val">
          @if (newUsername() !== null) {
            <input
              #userNameField
              (keydown.enter)="applyChanges()"
              [(ngModel)]="newUsername"
              class="el-val-text input-field"
              type="text" />
            <div class="button-row">
              <button
                (click)="applyChanges()"
                (keydown.enter)="applyChanges()"
                class="el-icon fab-icon"
                mat-mini-fab
                matTooltip="Save"
                tabindex="0">
                <mat-icon>check</mat-icon>
              </button>
              <button
                (click)="toggleUserNameEdit()"
                (keydown.enter)="toggleUserNameEdit()"
                class="el-icon fab-icon"
                mat-mini-fab
                matTooltip="Cancel"
                tabindex="0">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          } @else {
            <div class="el-val-text">{{ userInfo.userName }}</div>
            <button
              (click)="toggleUserNameEdit()"
              (keydown.enter)="toggleUserNameEdit()"
              class="el-icon"
              mat-icon-button
              tabindex="0">
              <mat-icon>edit</mat-icon>
            </button>
          }
        </div>
      </div>
    </div>
    <mat-divider style="margin: 5px 0"></mat-divider>
    <div class="password-container">
      <h4>Password</h4>
      <span class="sub-text">
        Modify your current password. <br />
        The new password must have lower case, upper case and numeric characters.
      </span>
      <app-change-pwd-form [userId]="userInfo.userId"></app-change-pwd-form>
    </div>

    <mat-divider style="margin: 10px 0"></mat-divider>
    <div class="deletion-container">
      <h4>Job Data</h4>
      <span class="sub-text"
        >This will permanently delete all data associated with your jobs. Once deleted, this action
        cannot be undone, and all related information will be erased from the system.
      </span>
      <div style="margin-top: 20px">
        <button mat-raised-button color="primary" (click)="requestDataDelete()">
          Delete all data
        </button>
      </div>
    </div>
  </div>
}
